
import AppLogDataTable from "@/components/LogsDataTable.vue";
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";
import AppBrowsePagination from "../components/BrowsePagination.vue";
import { LogEntry } from "@/models/log";
import { LogService } from "@/services/log-service";
import { HumanFilter } from "@/utils/browse/human-filter";
import { CompanyService } from "@/services/company-service";
import { setTitle, resetTitle } from "@/utils/title";

export default Vue.extend({
	data() {
		return {
			logs: [] as LogEntry[],
			selected: [] as LogEntry[],
			orderColumn: "this.TimeStamp",
			ascending: false,
			limit: 50,
			page: 1,
			records: 0,
			apps: [] as string[],
			selectedApp: "",
			filters: [] as HumanFilter[],
			openedStack: null as null | LogEntry,
			purgeLogsOlderThenDateData: {
				open: false,
				date: new Date()
			}
		};
	},
	computed: {
		appItems():ISelectItem<string>[] {
			return this.apps.map(a => {
				return {
					value: a,
					text: a
				};
			});
		},
		orderDir():string {
			return this.ascending ? "ASC" : "DESC";
		},
		openedStackMessageLines():string[]{
			if (!this.openedStack) return [];
			return (this.openedStack.stack ||  this.openedStack.message).split("\n");
		}
	},
	methods: {
		openStack(){
			if (this.selected.length != 1) return;
			this.openedStack = this.selected[0];
		},
		closeStack(){
			this.openedStack = null;
		},
		async fetchApps():Promise<void> {
			this.apps = await LogService.getApps();
			if (!this.selectedApp) {
				this.selectedApp = this.apps[0];
			}
		},
		async fetch() {
			let filters = this.filters.concat([new HumanFilter({Field: "this.App", Operator: "=", Values: [this.selectedApp]})]);
			let res = await LogService.getLogEntries(filters, this.orderColumn, this.orderDir, this.page, this.limit);
			this.logs = res.items;
			if (this.page == 1){
				this.records = res.count;
			}
		},
		onView(app:string){
			this.selectedApp = app;
			this.fetch();
		},
		onLimitChange(limit:number) {
			this.limit = limit;
			this.fetch();
		},
		onNewPage(page:number) {
			this.page = page;
			this.fetch();
		},
		onOrder(order:{ascending:boolean, order:string}) {
			this.orderColumn = order.order;
			this.ascending = order.ascending;
			this.fetch();
		},
		async deleteLogs():Promise<void> {
			await LogService.deleteLogEntries(this.selected);
			await this.fetch();
		},
		async openCompany(log?:LogEntry){
			let selected = log;
			if (!selected){
				selected = this.selected[0];
			}
			let comp = await CompanyService.getCompanyByDossierID(selected.dossierId);
			this.$router.push(`/companies/${comp.id}/dossier/${this.selected[0].dossierId}/edit`);
		},
		async purgeLogs(){
			let message = `Weet je zeker dat je ALLE logs van de app ${this.selectedApp} wilt verwijderen? Dit kan niet ongedaan gemaakt worden.`;
			let confirm = await this.$wf.confirm(message, "Ja", "Nee", "Waarschuwing", "danger");
			if (!confirm) return;
			let deletedCount = await LogService.deleteLogsByAppName(this.selectedApp);
			this.$wf.notify(`Er zijn ${deletedCount} logs verwijderd.`, "info", 3000, "info");
			this.fetch();
		},

		async purgeLogsOlderThenDate(){
			let message = `Weet je zeker dat je ALLE logs van de app ${this.selectedApp} wilt verwijderen? Dit kan niet ongedaan gemaakt worden.`;
			let confirm = await this.$wf.confirm(message, "Ja", "Nee", "Waarschuwing", "danger");
			if (!confirm) return;
			let deletedCount = await LogService.deleteLogsByAppNameOlderThenDate(this.selectedApp, this.purgeLogsOlderThenDateData.date);
			this.$wf.notify(`Er zijn ${deletedCount} logs verwijderd.`, "info", 3000, "info");
			this.fetch();
			this.purgeLogsOlderThenDateData.open = false;
		}
	},
	async created() {
		setTitle("Logs");
		await this.fetchApps();
		await this.fetch();
	},
	destroyed(){
		resetTitle();
	},
	components: {
		AppLogDataTable,
		AppBrowsePagination
	},
});
